import carousel from './carousel'
import plangridTrackEvents from "./amplitudeInit-vanilla";
import getPageNameFromLocation from "../../pages/helpers/getPageNameFromLocation";

export const init = () => {
  const pageName = getPageNameFromLocation(window.location.href);
  plangridTrackEvents(pageName);

  const slider = carousel({
    autoplayTime: 5000,
    carouselContainer: document.querySelector('.carousel'),
    nextButton: document.querySelector('.carousel-forward'),
    previousButton: document.querySelector('.carousel-backward'),
    pagingContainer: document.querySelector('.carousel-navigation')
  })
}

document.addEventListener('DOMContentLoaded', init)



// WEBPACK FOOTER //
// ./src/assets/js/caseStudyPage.js